/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Changelog_Previous1Inputs */

const id_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelumnya`)
};

const ms_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelum`)
};

const da_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forrige`)
};

const de_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige`)
};

const en_us2_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const es_es2_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const es_mx2_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const fil_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakaraan`)
};

const fr_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Précédent`)
};

const it_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precedente`)
};

const hu_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Előző`)
};

const nl_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorige`)
};

const no_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forrige`)
};

const pl_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprzednia`)
};

const pt_br2_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const pt_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const ro_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const fi_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edellinen`)
};

const sv_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Föregående`)
};

const vi_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trước`)
};

const tr_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önceki`)
};

const cs_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předchozí`)
};

const bg_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предишен`)
};

const ru_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад`)
};

const uk_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад`)
};

const ar_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السابق`)
};

const hi_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछला`)
};

const th_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ก่อนหน้า`)
};

const ja_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前へ`)
};

const zh_cn2_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上一页`)
};

const zh_hant1_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上一頁`)
};

const ko_offerdetail_changelog_previous1 = /** @type {(inputs: Offerdetail_Changelog_Previous1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이전`)
};

/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Offerdetail_Changelog_Previous1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_changelog_previous1 = /** @type {((inputs?: Offerdetail_Changelog_Previous1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Changelog_Previous1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_changelog_previous1(inputs)
	if (locale === "ms") return ms_offerdetail_changelog_previous1(inputs)
	if (locale === "da") return da_offerdetail_changelog_previous1(inputs)
	if (locale === "de") return de_offerdetail_changelog_previous1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_changelog_previous1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_changelog_previous1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_changelog_previous1(inputs)
	if (locale === "fil") return fil_offerdetail_changelog_previous1(inputs)
	if (locale === "fr") return fr_offerdetail_changelog_previous1(inputs)
	if (locale === "it") return it_offerdetail_changelog_previous1(inputs)
	if (locale === "hu") return hu_offerdetail_changelog_previous1(inputs)
	if (locale === "nl") return nl_offerdetail_changelog_previous1(inputs)
	if (locale === "no") return no_offerdetail_changelog_previous1(inputs)
	if (locale === "pl") return pl_offerdetail_changelog_previous1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_changelog_previous1(inputs)
	if (locale === "pt") return pt_offerdetail_changelog_previous1(inputs)
	if (locale === "ro") return ro_offerdetail_changelog_previous1(inputs)
	if (locale === "fi") return fi_offerdetail_changelog_previous1(inputs)
	if (locale === "sv") return sv_offerdetail_changelog_previous1(inputs)
	if (locale === "vi") return vi_offerdetail_changelog_previous1(inputs)
	if (locale === "tr") return tr_offerdetail_changelog_previous1(inputs)
	if (locale === "cs") return cs_offerdetail_changelog_previous1(inputs)
	if (locale === "bg") return bg_offerdetail_changelog_previous1(inputs)
	if (locale === "ru") return ru_offerdetail_changelog_previous1(inputs)
	if (locale === "uk") return uk_offerdetail_changelog_previous1(inputs)
	if (locale === "ar") return ar_offerdetail_changelog_previous1(inputs)
	if (locale === "hi") return hi_offerdetail_changelog_previous1(inputs)
	if (locale === "th") return th_offerdetail_changelog_previous1(inputs)
	if (locale === "ja") return ja_offerdetail_changelog_previous1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_changelog_previous1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_changelog_previous1(inputs)
	return ko_offerdetail_changelog_previous1(inputs)
});
export { offerdetail_changelog_previous1 as "offerDetail.changelog.previous" }